<div 
  class="toast-notification" 
  [ngClass]="'toast-' + type"
  [@toastAnimation]="animationState"
  (@toastAnimation.done)="animationState === 'hidden' ? onClose() : null">
  <div class="toast-icon">
    <i [class]="iconClass"></i>
  </div>
  <div class="toast-content">
    <p class="toast-message">{{ message }}</p>
  </div>
  <button class="toast-close" (click)="hide()">
    <i class="bi bi-x"></i>
  </button>
</div>
